import { palette } from './tokens';
/**
 * KİMLİK EKRANLARI — VAAT YÖNÜ (kullanıcı kararı 07.09.2026, B "VAAT").
 * Referans: `docs/design/giris-vaat/Main.dc.html` (1440) + `BMobil.dc.html` (390).
 *
 * İki grup, TEK kaynak:
 *  · `authGeometry` — form ≤ 400, kolon yan/dikey dolgusu 72/40, sağ panel
 *    metni ≤ 460, dar ekranda üstte 320 px bant. Boşluk merdiveninde olmayan
 *    referans değerleri (72 · 40 · 64) kolon anatomisidir, ritim değil — kabuk
 *    sözleşmesi 232/240/344/420 sütunlarını nasıl tanıyorsa bu kolonu da öyle
 *    tanır.
 *
 *    SABİT KOLON GENİŞLİĞİ (`column: 620`) KALDIRILDI — kullanıcı kararı
 *    08.09.2026: "resim bulunan sağ kart ile soldaki form kartı birbirinden
 *    ayrılmıyor ve iki kartın boyutu eşit değil". Kabuk artık TEK kartın içinde
 *    620/496 iki blok değil, aralarında site oluğu (`--ib-gap`) olan İKİ EŞİT
 *    karttır; kolon genişliği `1fr`den gelir ve sabit sayı taşımaz. Referansın
 *    620'si beyanlı sapma olarak `auth-anatomy.guard`ta artboard'dan OKUNUR —
 *    artboard değişirse kapı yine kırılır. Form 400'ün altına düşmesin diye
 *    kolonun yan dolgusu 72 bir TAVANDIR: dar kartta `min()` ile daralır
 *    (`auth-screen.module.css`), form daralmaz.
 *  · `authPanel` — koyu editoryal panelin renkleri. TEMADAN BAĞIMSIZDIR: panel
 *    açık temada da koyudur (bilinçli; karar belgesi "Giriş yönü — vaat").
 *    Renkler paletten OKUNUR, burada yeni hex doğmaz.
 *
 * CSS'e `--ib-auth-*` olarak `packages/ui/src/theme-css.ts` basar; kapı
 * `auth-anatomy.guard.spec.ts` referans HTML'den okuduğu sayıyla iki yönlü pinler.
 */
export const authGeometry = {
    form: 400,
    columnPadX: 72,
    columnPadY: 40,
    panelText: 460,
    panelPadX: 64,
    panelPadY: 72,
    band: 320,
};
export const authPanel = {
    /** Zemin ve metin — üst bant kromuyla aynı set (`dark.bg` / `dark.ink`). */
    bg: palette.dark.bg,
    ink: palette.dark.ink,
    inkMuted: palette.dark.ink2,
    inkFaint: palette.dark.ink3,
    /** Kicker ve sıcak temas noktası — karanlık temanın vurgusu. */
    accent: palette.dark.accent,
    /** Çizim: büyük daire (primaryTint) + ikinci daire (primary 600). */
    glow: palette.dark.primaryTint,
    glowDeep: palette.primary[600],
    /** Konuşma yayları: birincil (primary 500) ve vurgu (accent 500). */
    arc: palette.primary[500],
    arcAccent: palette.accent[500],
    /** Soğuk temas noktası — karanlık temanın birincili. */
    point: palette.dark.primary,
    /** Karanlık temada panel ile sayfa zemini aynı; ayrımı 1px bu çizgi yapar. */
    line: palette.dark.line,
};
//# sourceMappingURL=auth-panel.js.map